const validate2fa = (value) => {
  let error;

  if (!value) {
    error = "required field";
  } else if (!/^[A-Za-z0-9]{6}$/.test(value)) {
    error = "invalid code";
  }

  return error;
};

export default validate2fa;
